export default "__VITE_ASSET__IEEyyiX2__"